import { useCallback } from 'react';
import { Annotation, AnnotationType, TextAnnotation } from '@v2/components/imageHandling/components/DrawingCanvas/types';
import { ANNOTATION_TYPE_LABELS } from '@v2/components/imageHandling/components/DrawingCanvas/constants';
import i18n from 'i18n-js';

interface UseManageMobileAnnotationListParams {
  annotations: Annotation[];
  selectedId: string | null;
  onSelect: (id: string | null) => void;
  onToggleExpanded: () => void;
}

export const useManageMobileAnnotationList = ({
  annotations,
  selectedId,
  onSelect,
  onToggleExpanded,
}: UseManageMobileAnnotationListParams) => {
  const handleHeaderPress = useCallback(() => onToggleExpanded(), [onToggleExpanded]);

  const handleItemPress = useCallback((id: string) => onSelect(selectedId === id ? null : id), [onSelect, selectedId]);

  const getItemLabel = useCallback((annotation: Annotation, index: number) => {
    const base = i18n.t(ANNOTATION_TYPE_LABELS[annotation.type]);
    return annotation.type === AnnotationType.Text ? `${base} "${(annotation as TextAnnotation).text}"` : `${base} #${index + 1}`;
  }, []);

  return {
    annotationsCount: annotations.length,
    handleHeaderPress,
    handleItemPress,
    getItemLabel,
  };
};
